// export const isTouchDevice = () => {
//   const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
//   const mq = (query) => {
//     return window.matchMedia(query).matches;
//   };

//   if (
//     'ontouchstart' in window ||
//     // eslint-disable-next-line no-undef
//     (window.DocumentTouch && document instanceof DocumentTouch)
//   ) {
//     return true;
//   }

//   // include the 'heartz' as a way to have a non matching MQ to help terminate the join
//   // https://git.io/vznFH
//   const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join(
//     ''
//   );
//   return mq(query);
// }

export const disableScrolling = () => {
  const docHeight = document.body.clientHeight;
  const windowHeight = window.innerHeight;

  if (docHeight > windowHeight) {
    const html = document.documentElement;
    const { scrollTop } = html;
    html.classList.add('disable-scrolling');
    html.style.top = `${-scrollTop}px`;
  }
};

export const enableScrolling = () => {
  const { top } = getComputedStyle(document.documentElement);
  const scrollTop = parseInt(top, 10);
  const html = document.documentElement;
  html.classList.remove('disable-scrolling');
  html.scrollTop = -scrollTop;
  html.style.top = '';
};

// random number in range
export const randomInRange = (min: number, max: number) => {
  return Number(Math.random() * (max - min) + min);
};
